import React from 'react';

import {
  MarketBadDebtRatingInfo,
  MarketManipulationComplexityRatingInfo,
  Rating,
} from 'domain/types';
import { Either } from 'utils/either';

import { MarketBadDebtTranscription } from './MarketBadDebtTranscription';
import { MarketManipulationComplexityTranscription } from './MarketManipulationComplexityTranscription';

export function MarketRatingTranscription({
  manipulationComplexityInfo,
  badDebtInfo,
  marketRating,
}: {
  manipulationComplexityInfo: MarketManipulationComplexityRatingInfo | null;
  badDebtInfo: MarketBadDebtRatingInfo | null;
  marketRating: Either<Rating>;
}) {
  if (manipulationComplexityInfo && badDebtInfo) {
    if (manipulationComplexityInfo.rating.rating === badDebtInfo.rating.rating) {
      return marketRating.fold(
        r => r,
        () => 0,
      ) > 1 ? (
        <MarketBadDebtTranscription {...badDebtInfo} />
      ) : (
        <MarketManipulationComplexityTranscription {...manipulationComplexityInfo} />
      );
    }

    return manipulationComplexityInfo.rating.rating > badDebtInfo.rating.rating ? (
      <MarketManipulationComplexityTranscription {...manipulationComplexityInfo} />
    ) : (
      <MarketBadDebtTranscription {...badDebtInfo} />
    );
  }

  return (
    <>
      {manipulationComplexityInfo && (
        <MarketManipulationComplexityTranscription {...manipulationComplexityInfo} />
      )}
      {badDebtInfo && <MarketBadDebtTranscription {...badDebtInfo} />}
    </>
  );
}
